<div class="lm-columnar-adhoc-report-dimensions-flyout">
  <div class="lm-columnar-dimensions-title">
    <h4 class="lm-bold lm-header-4" data-automation-id="lm-columnar-adhoc-report-dimensions-header">{{dimensionsHeader}}</h4>
  </div>
  <div class="lm-columnar-adhoc-report-dimensions scrollable-y"
      cdkDropList
      [id] = "DIMENSIONS_LIST"
      [cdkDropListConnectedTo] = "DIMENSIONS_LIST"
      [cdkDropListData]="DIMENSIONS_LIST"
      [cdkDropListEnterPredicate]="canDrop"
      (cdkDropListDropped)="drop($event)"
  >
    @for (dim of dimensions; track dim; let i = $index) {
      <div class="lm-adhoc-facade-field" cdkDrag [cdkDragData]="dim">
        <div *cdkDragPreview class="lm-columnar-adhoc-report-dimensions">
          <svg cdkDragHandle soho-icon class="lm-icon" [icon]="'drag'" soho-tooltip [content]="'Drag Me'"/>
          <div><p>{{dim.label.resourceValue }}</p></div>
        </div>
        <svg cdkDragHandle soho-icon class="lm-icon" [icon]="'drag'" soho-tooltip [content]="'Drag Me'"  [attr.data-automation-id]="'lm-dimension-' + i + '-drag-icon'"/>
        <p [attr.data-automation-id]="'lm-dimension-' + i + '-txt'">{{ dim.label.resourceValue }}</p>
        <button type="button"><svg soho-icon icon="delete" (click)="removeDimension(i)"></svg></button>
      </div>
    }
  </div>
  <div class="lm-columnar-dimensions-title">
    <h4 class="lm-bold lm-header-4" data-automation-id="lm-columnar-adhoc-report-available-dimensions-header">{{availableDimensionsHeader}}</h4>
  </div>
  <div class="lm-columnar-adhoc-report-available-dimensions scrollable-y">
    @for (field of availableDimensions; track field; let i = $index) {
      <div class="lm-adhoc-facade-field">
        <p [attr.data-automation-id]="'lm-available-dimension-' + i + '-txt'">{{ field.name }}</p>
        <button type="button"><svg soho-icon icon="add" (click)="addDimension(i)"></svg></button>
      </div>
    }
  </div>
</div>
